import type { FC, PropsWithChildren } from 'react';
import React from 'react';

import type { IClassNameProps } from '@bem-react/core';

import { cnTextarea } from '../Textarea.cn';

import './Textarea-Box.css';

export type TextareaBoxProps = PropsWithChildren<IClassNameProps>;

export const TextareaBox: FC<TextareaBoxProps> = ({ className, children, ...props }) => (
    <span {...props} className={cnTextarea('Box', null, [className])}>
        {children}
    </span>
);
